// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const StockSlashCircleOutOfStock: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#8d8179", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9.438 10.468 2.032 3.062a5.25 5.25 0 0 0 7.406 7.406m.53-.53a5.25 5.25 0 0 0-7.406-7.406zM0 6.5a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
            />
        </svg>
    );
};

export default React.memo(StockSlashCircleOutOfStock);
